import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
const todayYear = new Date().getFullYear();
const todayMonth = new Date().getMonth();
const todayDay = new Date().getDate();
const end = new Date(todayYear, todayMonth, todayDay, "23", "59", "59");
const start = new Date(todayYear, todayMonth, todayDay, "00", "00", "00");
export default Vue.extend({
  data() {
    return {
      searchItems: [],
      searchObj: {},
      pickerOptions: {
        shortcuts: [{
          text: "今天",
          onClick(picker) {
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一周",
          onClick(picker) {
            picker.$emit("pick", [new Date(start.getTime() - 3600 * 1000 * 24 * 7), end]);
          }
        }, {
          text: "最近一个月",
          onClick(picker) {
            picker.$emit("pick", [new Date(start.getTime() - 3600 * 1000 * 24 * 30), end]);
          }
        }, {
          text: "最近三个月",
          onClick(picker) {
            picker.$emit("pick", [new Date(start.getTime() - 3600 * 1000 * 24 * 90), end]);
          }
        }]
      },
      newPickerOptions: {
        disabledDate: time => {
          let nowDate = new Date();
          let endTime = new Date(nowDate.toLocaleDateString() + " 23:59:59").getTime();
          return time.getTime() > endTime;
        },
        shortcuts: [{
          text: "今天",
          onClick(picker) {
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一周",
          onClick(picker) {
            picker.$emit("pick", [new Date(start.getTime() - 3600 * 1000 * 24 * 7), end]);
          }
        }, {
          text: "最近一个月",
          onClick(picker) {
            picker.$emit("pick", [new Date(start.getTime() - 3600 * 1000 * 24 * 30), end]);
          }
        }, {
          text: "最近三个月",
          onClick(picker) {
            picker.$emit("pick", [new Date(start.getTime() - 3600 * 1000 * 24 * 90), end]);
          }
        }]
      },
      isSpread: false,
      formHeight: 0,
      observer: null
    };
  },
  model: {
    prop: "queryObj",
    event: "value-change"
  },
  props: {
    setting: {
      type: Object,
      default: function () {
        return {};
      }
    },
    searchOption: {
      type: Array,
      default: function () {
        return [];
      }
    },
    searchBtnLoading: {
      type: Boolean,
      default: false
    },
    queryObj: {
      type: Object,
      default: function () {
        return {};
      }
    },
    questionContent: {
      type: String,
      default: ""
    },
    hideHeight: {
      type: Number,
      default: 150
    }
  },
  watch: {
    searchOption() {
      this.setSearchItems();
    },
    queryObj: {
      handler() {
        this.walkObj(this.queryObj, function (value, key) {
          this.$set(this.searchObj, key, value);
        }, this);
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.setSearchItems();
  },
  mounted() {
    this.formHeight = this.$refs.form.$el.offsetHeight;
    let MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    this.observer = new MutationObserver(() => {
      this.formHeight = this.$refs.form.$el.offsetHeight;
    });
    this.observer.observe(this.$refs.form.$el, {
      childList: true,
      // 子节点的变动（新增、删除或者更改）
      attributes: true,
      // 属性的变动
      characterData: true,
      // 节点内容或节点文本的变动
      subtree: true // 是否将观察器应用于该节点的所有后代节点
    });
    window.addEventListener("resize", this.changeFormHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.changeFormHeight);
    this.observer.disconnect();
    this.observer.takeRecords();
    this.observer = null;
  },
  methods: {
    recursiveCascader(cascaderOptions, curCheckedList, item, valueLevelList) {
      for (let i = 0; i < cascaderOptions.length; i++) {
        valueLevelList.push(cascaderOptions[i][item.props.value]);
        if (cascaderOptions[i][item.props.children] && cascaderOptions[i][item.props.children].length > 0) {
          this.recursiveCascader(cascaderOptions[i][item.props.children], curCheckedList, item, valueLevelList);
        } else {
          curCheckedList.push([...valueLevelList]);
          valueLevelList.splice(cascaderOptions[i][item.levelKey] - 1, valueLevelList.length - cascaderOptions[i][item.levelKey] + 1);
        }
        if (i == cascaderOptions.length - 1) valueLevelList.pop();
      }
    },
    cascaderSelectAll(item, val) {
      item.isIndeterminate = false;
      if (val == true) {
        const curCheckedList = [];
        this.recursiveCascader(item.cascaderOptions, curCheckedList, item, []);
        this.searchObj[item.key] = curCheckedList;
      } else {
        this.searchObj[item.key] = [];
      }
      this.valueChange(item.key);
    },
    cascaderArrayValueChange(item) {
      const checkedCount = this.searchObj[item.key].length;
      item.checkAll = checkedCount === item.totalNum;
      item.isIndeterminate = checkedCount > 0 && checkedCount < item.totalNum;
      this.valueChange(item.key);
    },
    selectAll(item, val) {
      item.isIndeterminate = false;
      if (val) {
        this.searchObj[item.key] = item.selectOptions.map(option => {
          return option.value;
        });
      } else this.searchObj[item.key] = [];
      this.valueChange(item.key);
    },
    selectArrayValueChange(item) {
      const checkedCount = this.searchObj[item.key].length;
      item.checkAll = checkedCount === item.selectOptions.length;
      item.isIndeterminate = checkedCount > 0 && checkedCount < item.selectOptions.length;
      this.valueChange(item.key);
    },
    setSearchItems() {
      console.log("setSearchItems");
      this.searchItems = this.searchOption;
      const remoteSelectOptions = this.searchItems.filter(item => item.type === "select" && item.selectOptionsApi && !item.selectOptions);
      if (remoteSelectOptions.length) this.getRemoteSelectOptions(remoteSelectOptions);
      const remoteCascaderOptions = this.searchItems.filter(item => item.type === "cascader" && item.cascaderOptionsApi && !item.cascaderOptions);
      if (remoteCascaderOptions.length) this.getRemoteCascaderOptions(remoteCascaderOptions);
    },
    getRemoteCascaderOptions(remoteCascaderOptions) {
      remoteCascaderOptions.forEach(item => {
        let {
          fn
        } = item.cascaderOptionsApi;
        fn({}).then(res => {
          console.log("cascaderOptions", res);
          if (res.code === 200 && res.data) {
            item.cascaderOptions = res.data;
            this.updateItem(item.key, item);
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    getRemoteSelectOptions(remoteSelectOptions) {
      remoteSelectOptions.forEach(item => {
        let {
          fn,
          selectOptionKeyMap
        } = item.selectOptionsApi;
        if (!selectOptionKeyMap) {
          selectOptionKeyMap = {
            label: "value",
            // 接口返回的中文是value
            value: "key" // 接口返回的英文是key
          };
        }
        fn({}).then(res => {
          if (res.code === 200 && res.data) {
            item.selectOptions = res.data.map(i => ({
              label: i[selectOptionKeyMap.label],
              value: i[selectOptionKeyMap.value]
            }));
            this.updateItem(item.key, item);
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    updateItem(key, newItem) {
      const index = this.searchItems.findIndex(i => i.key === key);
      console.log("updateItem", key, newItem);
      this.searchItems.splice(index, 1, newItem);
    },
    changeFormHeight() {
      this.formHeight = this.$refs.form.$el.offsetHeight;
    },
    valueChange(key) {
      console.log("valueChange", this.searchObj, key);
      this.$emit("value-change", this.searchObj);
      this.$emit("form-item-change", key);
      this.$emit("change", this.searchObj);
    },
    resetForm() {
      this.$refs.form.resetFields();
    },
    walkObj(obj, handler, context) {
      let keys = Object.keys(obj);
      let len = keys.length;
      let key = null,
        value = null;
      for (let i = 0; i < len; i++) {
        key = keys[i];
        value = obj[key];
        if (handler) {
          let stop = handler.call(context, value, key, obj);
          if (stop) {
            return;
          }
        }
      }
    }
  }
});